import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityApiVolumeByApplication } from '@api/data-security';

export const getCoreDataSecurityApiVolumeByApplicationSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityApiVolumeByApplication',
	receive: true,
	request: true,
	requestHandler: getDataSecurityApiVolumeByApplication,
	retainDataOnRequest: true
});
